export default "__VITE_ASSET__BDAKyUKS__"